import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import ChatHeader from '../ChatHeader/ChatHeader'
import MessagesWrap from '../MessagesWrap'

import { styles } from './styles'
import { clearActiveUser, saveActiveUser, ACTIVE_USER_SESSION_KEY } from '../../actions/activeUser'

const ChatContainer = (props) => {
  const { classes, match, activeUserId } = props
  const { chatId } = match.params

  useEffect(() => {
    if (!activeUserId) {
      try {
        const stored = sessionStorage.getItem(ACTIVE_USER_SESSION_KEY)
        if (stored) {
          const parsed = JSON.parse(stored)
          if (parsed.chatId === chatId) {
            saveActiveUser(parsed)
          }
        }
      } catch {
        // ignore
      }
    }

    return () => {
      clearActiveUser()
    }
  }, [])

  return (
    <div className={classes.container}>
      <ChatHeader />
      <MessagesWrap chatId={chatId} />
    </div>
  )
}

ChatContainer.propTypes = {
  classes: PropTypes.object,
  match: PropTypes.object.isRequired,
  activeUserId: PropTypes.string,
}

const mapStateToProps = state => ({
  activeUserId: state.activeUser.userId,
})

export default withStyles(styles)(withRouter(connect(mapStateToProps)(ChatContainer)))
